import { DTOInterestRecommendResponse } from 'src/apis/dto/DTOInterestRecommend';
import { DTOInterestsBulkRequest } from 'src/apis/dto/DTOInterestsBulkRequest';
import { useRestMutation, RestMutationOptions } from 'src/hooks/useRestMutation';

enum InterestsBulkApiList {
  InterestsBulk = '/api/v1/interests/bulk',
}

const useInterestsBulkMutation = (
  options?: RestMutationOptions<DTOInterestsBulkRequest, DTOInterestRecommendResponse, void>
) => {
  return useRestMutation<DTOInterestsBulkRequest, DTOInterestRecommendResponse>({
    method: 'post',
    path: InterestsBulkApiList.InterestsBulk,
    options,
  });
};

export default useInterestsBulkMutation;
